<template>
  <div :class="classes">
    <span>
      <slot />
    </span>
  </div>
</template>

<script lang="ts" setup>
import { computed, PropType } from 'vue'

const props = defineProps({
  variant: {
    type: String as PropType<'base' | 'primary' | 'secondary' | 'accent' | 'warning' | 'error' | 'success' | 'info'>,
    default: 'base'
  }
})

const baseClass = 'base-badge inline-flex items-center rounded-md font-semibold'
const colorClass = {
  base: 'bg-slate-100 text-slate-950 hover:bg-slate-100',
  primary: 'bg-primary-400 text-white hover:bg-primary-500',
  secondary: 'bg-secondary text-slate-950 hover:bg-secondary/80',
  accent: 'bg-accent text-slate-950 hover:bg-accent/80',
  warning: 'bg-warning text-slate-950 hover:bg-warning/80',
  error: 'bg-error text-slate-950 hover:bg-error/80',
  success: 'bg-success text-slate-950 hover:bg-success/80',
  info: 'bg-info text-slate-950 hover:bg-info/80',
}
const sizeClass = 'px-2 py-1 text-xs'
const classes = computed(() => [baseClass, colorClass[props.variant], sizeClass])
</script>
